import React, { useEffect, useState, useRef } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';

import api from './../../service/api';

import CreateExpenseCategory from './create';

export default function ExpenseCategory(){
    var emptyExpenseCategory = {
        code: null,
        description: ''
    }

    const [expenseCategory, setExpenseCategory] = useState(emptyExpenseCategory);
    const [expensesCategory, setExpensesCategory] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [updateDialog, setUpdateDialog] = useState(false);
    const [dialog, setDialog] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);

    const toast = useRef(null);
    const dt = useRef(null);

    const listExpenseCategory = () => {
        api().get('expensecategory/list').then(response => {
            if(response.status === 200 && response.data.result){
                setExpensesCategory(response.data.data);
            }
        });
    }

    const onInputChange = (e, name) => {
        const val = e.value || (e.target && e.target.value) || '';
        let _expenseCategory = { ...expenseCategory };
        _expenseCategory[`${name}`] = val;

        setExpenseCategory(_expenseCategory);
    }

    const openNew = () => {
        setExpenseCategory(emptyExpenseCategory);
        setSubmitted(false);
        setDialog(true);
        setDisabled(false);
    }

    const confirmDelete = (_expenseCategory) => {
        setExpenseCategory({ ..._expenseCategory });
        setDeleteDialog(true);
    }

    const hideDeleteDialog = () => {
        setExpenseCategory({ ...emptyExpenseCategory });
        setDeleteDialog(false);
    }

    const handleDelete = () => {
        setDisabled(true);
        api().delete('/expensecategory/' + expenseCategory.code).then(response => {
            if(response.status === 200 && response.data.result) {
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listExpenseCategory();
            } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
            setExpenseCategory(emptyExpenseCategory);
            setDisabled(false);
            setDeleteDialog(false);
        });
    }

    const onHide = () => {
        setExpenseCategory({...emptyExpenseCategory});
        setUpdateDialog(false);
    }

    const onCreate = (data) => {
        setDialog(false);
        if(data.result) listExpenseCategory();
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Nova categoria" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        )
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Gerenciar Categoria de Despesas</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
            </span>
        </div>
    );

    const actionBodyTemplate = (rowData) => {
        if(![1].includes(rowData.code))
            return (
                <div className="actions">
                    <Button icon="pi pi-pencil" className="p-button-rounded p-button-info mr-2" onClick={() => {
                        setExpenseCategory({...rowData});
                        setUpdateDialog(true);
                    }} />
                    <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mt-2" onClick={() => confirmDelete(rowData)} />
                </div>
            );
    }

    const deleteDialogFooter = (
        <>
            { !disabled && <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />}
            <Button label="Sim" icon="pi pi-check" loading={disabled} className="p-button-text" onClick={handleDelete} />
        </>
    );

    useEffect(() => {
        listExpenseCategory()
    }, []);

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>
                    <CreateExpenseCategory visible={dialog} disabled={disabled} onCreate={onCreate} handleCancel={() => setDialog(false)} />

                    <DataTable ref={dt} value={expensesCategory} 
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column field="description" sortable header="Descrição"></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>

                    <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Atenção" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {expenseCategory && <span>Você tem certeza que deseja remover esta categoria de despesa?</span>}
                        </div>
                    </Dialog>

                    <Dialog visible={updateDialog} style={{ width: '450px' }} header="Alterar Categoria de Despesa" modal className="p-fluid" footer={() => {
                        return(
                            <>
                                <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={onHide} />
                                <Button label="Salvar" onClick={() => {
                                    if(!expenseCategory.description) return setSubmitted(true);

                                    setDisabled(true);
                                    api().post('/expensecategory/update', {...expenseCategory}).then(response => {
                                        setDisabled(false);
                                        if(response.status === 200 && response.data.result){
                                            setUpdateDialog(false);
                                            listExpenseCategory();
                                            toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                                        } else {
                                            toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                                        }
                                    });

                                }} loading={disabled} icon="pi pi-check" className="p-button-text"  />
                            </>
                        );
                    }} onHide={onHide}>
                                    
                        <div className="field">
                            <label htmlFor="description">Descrição</label>
                            <InputText disabled={disabled} id="description" value={expenseCategory.description} onChange={(e) => onInputChange(e, 'description')} required autoFocus />
                            {submitted && !expenseCategory.description && <small className="p-invalid p-error">Este campo é obrigatório.</small>}
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    );    
}